import { useContext } from 'react';
import { Grid2 as Grid, Avatar, Box, Card, CardContent, CardHeader, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Alert, Link } from '@mui/material';
import { blue, green } from '@mui/material/colors';
import { FilersDataContext } from '../../../Filers';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { getReportTotalAmount } from '../../../../../utility/getReportTotalAmount';

const ReportLog = (): JSX.Element => {

    const filerDataContext = useContext(FilersDataContext);
    const reports = filerDataContext.currentFilerPayload?.logReports;

    const viewMoreReports = () => {
        filerDataContext.setContentType('Reports');
    }

    return (
        <Grid size={{ xs: 12, md: 5.5 }} marginTop={2} data-aos={'fade-up'}>
          <Card 
            sx={{
                "&:hover": {
                    boxShadow: "0 0 10px #ccc",
                },
                borderTop: `2px solid`,
                borderTopColor: green[700],
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                width: '100%',
                height: '100%',
              }}
            >
            <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: blue[500] }} className="small-avatar">
                        <SummarizeIcon fontSize="small" />
                    </Avatar>
                }
                padding={1}
                title={
                    <Typography variant="h6">
                    Recently Filed Reports
                    </Typography>
                }                                                      
            />                                                   
            <CardContent className="card-content">
                <Grid container spacing={1} data-aos={'fade-up'}>
                {
                    reports?.length===0?
                    <Box>
                        <Alert icon={false} severity="warning">
                            This filer has not filed any reports yet.
                        </Alert>
                    </Box>:
                     <TableContainer component={Paper}>
                        <Table aria-label="filer report log table" size="small">
                         <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                             <TableRow>
                                 <TableCell>
                                     <Typography variant={'caption'} fontWeight={600}>
                                     Report
                                     </Typography>
                                 </TableCell>
                                 <TableCell>
                                     <Typography variant={'caption'} fontWeight={600}>
                                     Total Amount
                                     </Typography>
                                 </TableCell>
                                 <TableCell>
                                     <Typography variant={'caption'} fontWeight={600}>
                                     Filed On
                                     </Typography>
                                 </TableCell>
                             </TableRow>
                         </TableHead>
                         <TableBody>
                             {reports?.map((report) => (
                                 <TableRow
                                 key={report.reportId}
                                 sx={{
                                     '&:last-child td, &:last-child th': { border: 0 },
                                 }}
                                 >
                                     <TableCell>
                                         <Typography variant={'subtitle2'}>
                                             <Link href={`/reports/displayreport?id=${report.reportId}`} target="_blank" underline="hover">{report.reportTypeDescription}</Link>
                                         </Typography>
                                         <Typography color={'text.secondary'} component={'i'} variant={'subtitle2'}>
                                             {report.reportingPeriod}
                                         </Typography>
                                     </TableCell>
                                     <TableCell>
                                         <Typography variant={'subtitle2'} fontWeight={550}>
                                             {getReportTotalAmount(report)}
                                         </Typography>
                                     </TableCell>
                                     <TableCell>
                                         <Typography variant={'subtitle2'}>
                                             {report.dateFiled}
                                         </Typography>
                                     </TableCell>
                                 </TableRow>
                             ))}
                         </TableBody>
                     </Table>
                    </TableContainer>
                } 
                {
                    reports && reports.length > 0 &&
                    <Grid size={12} display="flex" justifyContent="flex-end" marginTop={2}>
                        <Link className='is-clickable' onClick={viewMoreReports} underline='none' fontSize={"small"}><i>View More Reports</i></Link>
                    </Grid>
                } 
                </Grid>  
            </CardContent>                                               
          </Card>
        </Grid>
    );
  };

export default ReportLog;